import React from 'react';

import IosClose from 'react-icons/lib/io/ios-close';

import { TagOutlineIcon } from 'wanderu-components';

import styles from './DiscountError.scss';

import type { DiscountErrorCode } from '../discountSlice';
import type { TFunction } from 'i18next';

interface DiscountErrorProps {
    code: string;
    errorCode?: DiscountErrorCode;
    onRemove?: () => void;
    t: TFunction;
}

// Known error codes map to specific i18n keys. Unhandled codes (including
// UNKNOWN_ERROR) fall through to the generic 'discountCodeError' key.
const ERROR_MESSAGES: Partial<Record<DiscountErrorCode, string>> = {
    EXPIRED_DISCOUNT_CODE: 'discountCodeExpired',
    INVALID_CODE: 'discountCodeInvalid',
};

function DiscountError({
    code,
    errorCode,
    onRemove,
    t,
}: DiscountErrorProps) {
    if (!errorCode) return null;

    const messageKey = ERROR_MESSAGES[errorCode];
    const message = messageKey
        ? t(messageKey)
        : t('discountCodeError');

    return (
        <div className={styles.container} data-id="discount-error">
            <span className={styles.message}>{message}</span>
            <span className={styles.codeChip}>
                <TagOutlineIcon aria-hidden="true" className={styles.icon} />
                {code}
                {onRemove && (
                    <button
                        aria-label="Remove discount"
                        className={styles.removeButton}
                        onClick={onRemove}
                        type="button"
                    >
                        <IosClose aria-hidden="true" />
                    </button>
                )}
            </span>
        </div>
    );
}

export { DiscountError };
